<template>
  <validation-observer
        ref="loginForm"
        #default="{invalid}"
    >
        <b-form :class="formClass || 'form-login'" @submit.prevent="login">
            <b-form-group class="margin-input-email">
                <validation-provider #default="{ errors }"  name="Email" rules="required|email">
                    <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid':null">                       
                        <b-form-input
                        id="email"
                        v-model="userEmail"
                        :disabled="loading"
                        name="login-email"
                        :state="errors.length > 0 ? false:null"
                        placeholder="Email"
                        class="form-control-merge customize-input-login"
                        />
                        <b-input-group-append is-text class="customize-input-login">
                            <feather-icon class="cursor-pointer" icon="XCircleIcon" @click="clean"/>
                        </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>
            <b-form-group class="mt-1">
                <validation-provider #default="{ errors }" name="Password" rules="required">
                    <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid':null">
                        <b-form-input
                        id="password"
                        :disabled="loading"
                        v-model="password"
                        :type="passwordFieldType"
                        class="form-control-merge customize-input-login"
                        :state="errors.length > 0 ? false:null"
                        name="login-password"
                        :placeholder="$t('Contraseña')"
                        />

                        <b-input-group-append is-text class="customize-input-login">
                        <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility"/>
                        </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <b-link :to="{name:'recovery'}" class="lnk lnk-custom-blue push-right">
                    <small>{{$t('¿Olvidaste tu contraseña?')}}</small>
                </b-link>
            </b-form-group>
            <div id="recaptcha" class="text-center center-recaptcha"></div>
            <b-button class="mt-1 color-btn-login" type="submit" block :disabled="invalid || loading">
                <feather-icon v-if="loading" icon="LoaderIcon" class="spinner"/>
                {{$t('Iniciar sesión')}}
            </b-button>
            <div v-if="showContactLink" class="text-center">
                <a href="https://enviame.io/contactanos" target="_blank"><small>¿Aún no tienes cuenta? Contáctanos</small></a>
            </div>
        </b-form>
    </validation-observer>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BLink, BInputGroup, BInputGroupAppend
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import LoginService from '../../login.service'
import { environment } from '@/environments/environment'

export default {
  props: ['showContactLink', 'formClass'],
  components: {
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      password: '',
      userEmail: '',
      // validation rules
      required,
      email,
      loading: false,
      attempt: 1,
      tokenRecaptcha: 'norendered',
      widget: null,
      loginService: new LoginService(this)
    }
  },
  mounted () {
    this.setRecapchat()
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeOffIcon' : 'EyeIcon' 
    }
  },
  methods: {
    verifyCallback (token) {
      this.enableButton = true
      this.tokenRecaptcha = token
    },
    showRecaptcha (element, attempt, maxAttempt) {  
      if (attempt >= maxAttempt) {
        try {
          // eslint-disable-next-line no-undef
          const googleRecaptcha = grecaptcha.enterprise
          this.enableButton = false
          // Validar que este antes de renderizar
          if (typeof googleRecaptcha !== 'undefined' && googleRecaptcha.render) {
            if (this.tokenRecaptcha === 'norendered') {
              this.widget = googleRecaptcha.render(element, {
                'sitekey' : environment.recaptchaKey,
                'callback' : (token) => this.verifyCallback(token)
              })
            } else {
              googleRecaptcha.reset(this.widget)
            }
            this.tokenRecaptcha = 'notoken'
          }  
        } catch (error) {
          console.error('Error al cargar el recaptcha: ', error)  
        }
      }
    },
    async login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          this.attempt++
          if (this.tokenRecaptcha === 'norendered') {
            this.loading = true
            this.$emit('authentication', {email: this.userEmail, password: this.password})
          } else if (this.tokenRecaptcha === 'notoken') {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title:'Oops',
                icon: 'warning',
                variant: 'danger',
                text: 'Debe marcar la casilla "No soy un robot"'
              }
            })
          } else {
            this.loading = true
            // this.$recaptcha('loginForm').then((token) => {
            // this.tokenRecaptcha = token
            const params = { response: this.tokenRecaptcha, expectedAction: 'login' }
            this.loginService.callService('validateRecaptcha', params, params)
              .then(resp => {
                if (resp.data.tokenProperties?.valid) {
                  this.$emit('authentication', {email: this.userEmail, password: this.password})
                } else {
                  this.setRecapchat()
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title:'Oops',
                      icon: 'warning',
                      variant: 'danger',
                      text: `Hemos detectado actividad sospechosa para iniciar sesión. Por favor reintenta y si sigue pasando, contactate con nosotros. \n \n Problema: ${resp.reasons[0] || 'INVALID_REASON'}`
                    }
                  })
                  this.loading = false
                }
              })
              .catch(err => {
                let normalizedError = err
                if (!(err instanceof Error)) {
                  normalizedError = new Error(typeof err === 'string' ? err : JSON.stringify(err))
                }
                this.setRecapchat()
                this.loading = false
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title:'Oops',
                    icon: 'warning',
                    variant: 'danger',
                    text: `Hemos detectado problemas con la verificación de reCAPTCHA.\n \n Problema: ${normalizedError.message}`
                  }
                })
              })
            // })
          }
        } else {
          this.setRecapchat()
        }
      })
    },
    clean () {
      this.userEmail = ''
    },
    setRecapchat () {
      this.showRecaptcha('recaptcha', this.attempt, 1)
    },
    setLoading (value) {
      this.loading = value
    }
  }
}
</script>